import { Alert, Button, Col, Form, Input, Modal, Row, Table, Tooltip } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';

function Area() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setDataModal] = useState(null);
    const [form] = Form.useForm();
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        sorter: {
            order: 'desc',
            columnKey: 'area_id',
        }
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState('');

    // Page title
    const titlePage = 'Area Data';

    // Table columns configuration
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { 
                ++index; 
                return (page.pagination.current - 1) * page.pagination.pageSize + index;
            },
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: "name",
            sorter: true,
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: "created_at",
            sorter: true,
            render: (text, record) => {
                if (record.created_at !== "")
                    return (<p>{moment(record.created_at).format('DD-MM-YYYY HH:mm:ss')}</p>);
                else
                    return "-";
            }
        },
        {
            title: 'Updated At',
            dataIndex: 'updated_at',
            key: "updated_at",
            sorter: true,
            render: (text, record) => {
                if (record.updated_at !== "")
                    return (<p>{moment(record.updated_at).format('YYYY-MM-DD HH:mm:ss')}</p>);
                else
                    return "-";
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <>
                       <Tooltip title="Edit">
                            <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                                <EditOutlined />
                            </Button>
                        </Tooltip>

                        <Tooltip title="Delete">
                            <Button type="primary" danger onClick={() => confirmDelete(record)}>
                                <DeleteOutlined />
                            </Button>
                        </Tooltip>
                    </>
                );
            },
        },
    ];

    useEffect(() => {
        const order = page.sorter?.order ? (page.sorter.order === "ascend" ? 'asc' : 'desc') : 'desc';
        const columnKey = page.sorter?.columnKey || 'area_id';
        fetchApi("GET", `/area?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}&sortBy=${columnKey}&order=${order}`, 'area');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(page), isAlert]);

    const fetchApi = (method, url, type) => {
        setLoading(true);

        const dataReq = {
            method,
            url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };

        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setData(res.data.data);
                setPage({
                    ...page,
                    pagination: {
                        ...page.pagination,
                        total: res.data.total_data
                    }
                });
                setLoading(false);
            } else {
                setLoading(false);
            }
        }).catch((e) => {
            setLoading(false);
            console.error(e.message);
        });
    }

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method,
            url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setDataModal(null);
                setLoading(false);
                setIsAlert(true);
                setTextAlert(res.message);
                closeModal();
            } else {
                setLoading(false);
                modalError(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            console.error(e.message);
        });
    }

    const confirmDelete = (record) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Do you want to delete this data?',
            onOk: () => postApi('DELETE', `/area/${record.area_id}`, null),
        });
    }

    const openModal = (type, data) => {
        if (type === 'edit') {
            setDataModal(data);
            form.setFieldsValue({
                name: data.name,
                desc: data.desc,
            });
            setIsModal(true);
        } else {
            setIsModal(true);
        }
    }

    const onFinish = (values) => {
        if (dataModal !== null) {
            postApi("PUT", `/area/${dataModal.area_id}`, values);
        } else {
            postApi("POST", '/area', values);
        }
    }

    const closeModal = () => {
        setDataModal(null);
        setIsModal(false);
        form.resetFields();
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Area</h3>
            <Row>
                <Col span={8}>
                    <Search
                        placeholder="Search"
                        allowClear
                        enterButton="Search"
                        size="middle"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <Button style={{ marginBottom: 10 }} type="primary" onClick={() => openModal('add', null)}>
                        <PlusOutlined />
                        <b style={{ marginLeft: 5 }}>Add</b>
                    </Button>
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />
            <Modal title="Area Data" open={isModal} onOk={form.submit} onCancel={closeModal} okText="Save" >
                <Form form={form} name="form" layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="name"
                        label="Area Name"
                        rules={[
                            {
                                required: true,
                                message: 'Area Name is required!'
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="desc"
                        label="Description"
                    >
                        <Input.TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default Area;
